import React from 'react'
import {
  Route,
  createRoutesFromElements,
  createBrowserRouter,
} from 'react-router-dom'

import Login from '../pages/Auth/Login'
import Home from '../pages/Home'
import LoginWithEmail from '../pages/Auth/LoginWithEmail'
import Register from '../pages/Auth/Register'
import PublicLayout from '../components/layouts/PublicLayout'
import PrivateLayout from '../components/layouts/PrivateLayout'
import AvatarCreator from '../pages/AvatarSetup/AvatarCreator'
import AvatarMeet from '../pages/AvatarSetup/AvatarMeet'
import CreatorAvatarLayout from '../components/layouts/CreateAvatarLayout'
import AvatarSuccess from '../pages/AvatarSetup/AvatarSuccess'
import CourseDetails from '../pages/CourseDetails'
import AdminLayout from '../components/layouts/AdminLayout'
import Dashboard from '../pages/Admin/Dashboard'
import Users from '../pages/Admin/User/Users'
import UserDetails from '../pages/Admin/User/UserDetails'
import PublicRoute from './PublicRoute'
import PrivateRoute from './PrivateRoute'
import AdminRoute from './AdminRoute'
import LoginRedirect from '../pages/Auth/OCID/LoginRedirect'
import NotFoundPage from "../pages/NotFoundPage";
import SetupEmail from "../pages/Auth/SetupEmail";

const routes = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/ocid/redirect" element={<LoginRedirect />} />
      {/* Public Routes */}
      <Route path="/" element={<PublicRoute />}>
        <Route path="/" element={<PublicLayout />}>
          <Route path="login" element={<Login />} />
          <Route path="admin/login" element={<LoginWithEmail />} />
        </Route>
      </Route>

      {/* Private Routes */}
      <Route path="/" element={<PrivateRoute />}>
        <Route path="/" element={<CreatorAvatarLayout />}>
          <Route
            path="create-avatar"
            element={<AvatarCreator isCreating={true} />}
          />
          <Route
            path="update-avatar"
            element={<AvatarCreator isCreating={false} />}
          />
        </Route>
        <Route path="/" element={<PrivateLayout />}>
          <Route index element={<Home />} />
          <Route path="setup-email" element={<SetupEmail />} />
          <Route path="register" element={<Register />} />
          <Route path="meet-your-avatar" element={<AvatarMeet />} />
          <Route path="avatar-success" element={<AvatarSuccess />} />
          <Route path="sources/:id" element={<CourseDetails />} />
        </Route>
      </Route>

      {/* Admin Routes */}
      <Route path="/" element={<AdminRoute />}>
        <Route path="admin/" element={<AdminLayout />}>
          <Route index element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="users/:id" element={<UserDetails />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFoundPage />} />
    </>
  )
)

export default routes
